<div class="snack-content">
    <div class="snack-icon {{data.type}}">
        <mat-icon *ngIf="data.type === 'success'">check_circle</mat-icon>
        <mat-icon *ngIf="data.type === 'warning'">warning</mat-icon>
        <mat-icon *ngIf="data.type === 'error'">cancel</mat-icon>
    </div>
    <div class="snack-message">
        <div class="title">{{data.message}}</div>
        <div class="sub-title" [innerHTML]="data.subMessage"></div>
        <button mat-button class="mt-12" *ngIf="this.data.contactSupport" (click)="openSupport()">Soporte</button>
    </div>
</div>
  